import getters from './getters';
import mutations from './mutations';
import actions from './actions';

export default {
  namespaced: true,
  state: {
    user: null,
    errors: [],
  },
  getters,
  mutations,
  actions,
};
